import { AppIcons } from "../constants/app-icons";
import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class TransactionService extends ApiService {
  template = "defaultTemplate";
  DOMAIN = DOMAIN.TRANSACTION;
  icon = "RedCabinet";
  favicon = "FolderHorizontalClosed";
  singular = this.terminology.file.singular;
  plural = this.terminology.file.plural;
  vowel = this.terminology.file.vowel;
  Width = 690;
  gemItems = [
    {
      key: "create",
      label: "Change",
      icon: AppIcons.PLUS,
      services: -2,
    },
    {
      key: "create",
      label: "Check",
      icon: AppIcons.PLUS,
      services: -2,
    },
    {
      key: "create",
      label: "Journal Entry",
      icon: AppIcons.PLUS,
      services: -2,
    },
  ];

  constructor() {
    super("transaction");
  }
}
